import { Component, OnInit, Input } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FileService } from 'src/app/core/services/file.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import {NzModalRef} from "ng-zorro-antd/modal";

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss']
})
export class UploadImageComponent implements OnInit {
  @Input() image!: string;

  imageFileList: NzUploadFile[] = [];
  uploadedImages: any[] = [];

  isButtonLoading = false;
  editedTitle: string|undefined = "";

  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    private fileService: FileService,
    private loading: LoadingService,
    private translocoService: TranslocoService
  ) { }

  ngOnInit(): void {
    if (this.image) {
      this.imageFileList = [{
        uid: '-1',
        name: 'image',
        status: 'done',
        url: this.image
      }];
    }
  }

  handleChange({ file, fileList }: NzUploadChangeParam): void {
    const status = file.status;
    if (status === 'done') {
      this.msg.success(
        `${file.name} ${this.translocoService.translate('settings.uploadImage.messages.fileUploaded')}`
      );
    } else if (status === 'error') {
      this.msg.error(
        `${file.name} ${this.translocoService.translate('settings.uploadImage.messages.fileUploadFailed')}`
      );
    }
  }

  handleRemove = (file: NzUploadFile): boolean => {
    // Remove from imageFileList
    this.imageFileList = this.imageFileList.filter(
      f => f.uid !== file.uid
    );

    // Remove from uploadedImages array
    this.uploadedImages = this.uploadedImages.filter(
      image => image.uid !== file.uid
    );
    this.msg.success(
      `${file.name} ${this.translocoService.translate('settings.uploadImage.messages.fileRemoved')}`
    );

    return true;
  };

  customRequest = (item: any): any => {
    const fileToUpload = item.file;
    this.loading.start();
    return this.fileService.postFile(fileToUpload).subscribe({
      next: data => {
        this.loading.stop();

        const fileResponse = {
          uid: data.uid,
          name: data.name,
          status: data.status,
          url: data.url,
        };
        this.uploadedImages.push({
          name: data.name,
          url: data.url,
          uid: data.uid,
        });
        this.imageFileList.push(fileResponse as any);

        // Call onSuccess to update the file status
        item.onSuccess(fileResponse, item.file);
      },
      error: error => {
        this.loading.stop();
        item.onError(error, item.file);
      },
    });
  };

  handleCancel(): void {
    this.modal.close({message: "error"});
  }

  addUrl(): void  {
    this.isButtonLoading = true;
    this.modal.close({message: "success", url: this.imageFileList[0].url});
  }
}
